import {Component, EventEmitter, Input, Output} from "@angular/core";
import {FormService} from "../../services/form.service";
import {FormGroup} from "@angular/forms";
import {Observable} from "rxjs";
import {delay} from "rxjs/operators";

@Component({
    selector: 'binary-question',
    templateUrl: './binary-question.template.html',
    styleUrls: ['./binary-question.style.scss'],
    standalone: false
})
export class BinaryQuestionComponent {

	@Input() htmlIdPrefix: string;
	@Input() question: string;
	@Input() form: FormGroup;
	@Input() formKey: string;
	@Input() controlName: string;
	@Input() formService: FormService;
	@Output() answerProvided: EventEmitter<boolean> = new EventEmitter<boolean>();
	@Input() dataTestId: string;

	getRadioGroupName(): string {
		return `${this.htmlIdPrefix}${this.formKey ? '-' + this.formKey.toLowerCase() : ''}`;
	}

	isInvalid(): boolean {
		return this.formKey ? this.formService.isInvalid(this.formKey, this.controlName) : this.formService.isInvalid(this.controlName, null);
	}

	updateFormControl(value: any) {
		this.formService.updateFormControl(this.controlName, value, this.formKey);
		this.answerProvided.emit(value);
	}

	getErrorMessage(): Observable<string> {
		return this.formService.getErrorsString(this.formKey, this.controlName).pipe(delay(5000));
	}

	shouldDisableRadio(controlName: string): boolean {
		return this.formKey ? this.formService.getFormControl(this.formKey, controlName).disabled : this.formService.getFormControl(controlName, null).disabled;
	}

	fullControlName(): string {
		if (!!this.formKey) {
			return this.controlName.endsWith(this.formKey) ? this.controlName : this.controlName + this.formKey;
		}

		return this.controlName;
	}
}
